import { OptionType } from '@/shared/api/BaseAPI.model'
import { create } from 'zustand'

type ToppingsStore = {
  selectedLanguage: OptionType | null
  name: Record<string, string>
  description: Record<string, string>

  setSelectedLanguage: (lang: OptionType) => void
  setName: (value: string) => void
  setDescription: (value: string) => void
  reset: () => void
}

export const useToppingsDetailsStore = create<ToppingsStore>((set, get) => ({
  availableLanguages: [],
  selectedLanguage: null,
  name: {},
  description: {},

  setSelectedLanguage: lang => set({ selectedLanguage: lang }),

  setName: value => {
    const langCode = get().selectedLanguage?.value
    if (!langCode) return

    set(state => ({
      name: {
        ...state.name,
        [langCode]: value
      }
    }))
  },

  setDescription: value => {
    const langCode = get().selectedLanguage?.value
    if (!langCode) return

    set(state => ({
      description: {
        ...state.description,
        [langCode]: value
      }
    }))
  },

  reset: () =>
    set({
      selectedLanguage: null,
      name: {},
      description: {}
    })
}))
